import React, { Suspense } from 'react';
import { ErrorBoundary } from '@sparknz/journeys-common';
import { ShadowMode } from '@sparknz/online-web-shadow-mode';

import { useCartCookie, useSegment } from 'shared/hooks';

interface ShadowModeLoaderProps {
  apiURL: string;
  graphqlURL: string;
}

const IS_RECLAIM_CART_AVAILABLE = false;

export const ShadowModeInternal = ({
  apiURL,
  graphqlURL,
}: ShadowModeLoaderProps) => {
  const { channel } = useSegment();
  const { cartId } = useCartCookie();

  return (
    <ShadowMode
      apiUrl={apiURL}
      graphqlUrl={graphqlURL}
      cartId={cartId}
      channel={channel}
      isCartAgentDetailsPresent={IS_RECLAIM_CART_AVAILABLE}
      onReclaimCart={window.location.reload}
    />
  );
};

export const ShadowModeLoader = (props: ShadowModeLoaderProps) => {
  return (
    <ErrorBoundary fallback={() => <div />}>
      <Suspense fallback={<div />}>
        <ShadowModeInternal {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default ShadowModeLoader;
